import axios, { AxiosRequestConfig } from 'axios'
import { getJWT } from 'src/helper/localStore/getJWT'
import { BannerOutputDTO } from './bannerDTO'
import { IsAuthorized } from 'src/authentication/IsAuthorized'

class BannerServices {
  async getByAll(params: any): Promise<BannerOutputDTO[]> {
    try {
      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': getJWT()! },
      }

      if (params) {
        config.params = params
      }
      
      const res = await axios.get(`${process.env.REACT_APP_URL_RESERVATION}/banner/`, config)
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async uploadImages(data: any): Promise<BannerOutputDTO[]> {
    try {
      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': getJWT()! },
      }
      
      const res = await axios.post(`${process.env.REACT_APP_URL_RESERVATION}/banner/images`, data, config)
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async createBannerByWorkUnit(data: any): Promise<Object> {
    try {
      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': getJWT()! },
      }
      
      const res = await axios.post(`${process.env.REACT_APP_URL_RESERVATION}/banner-by-work-unit/`, data, config)
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async createBannerByBusinessUnit(data: any): Promise<Object> {
    try {
      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': getJWT()! },
      }
      
      const res = await axios.post(`${process.env.REACT_APP_URL_RESERVATION}/banner-by-business-unit/`, data, config)
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async updateBannerByWorkUnit(data: any): Promise<Object> {
    try {
      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': getJWT()! },
      }
      
      const res = await axios.put(`${process.env.REACT_APP_URL_RESERVATION}/banner-by-work-unit/`, data, config)
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async updateBannerByBusinessUnit(data: any): Promise<Object> {
    try {
      const config: AxiosRequestConfig = {
        headers: { 'authentication-token': getJWT()! },
      }
      
      const res = await axios.put(`${process.env.REACT_APP_URL_RESERVATION}/banner-by-business-unit/`, data, config)
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async deleteBannerByWorkUnit(data: any): Promise<Object> {
    try {
      const res = await axios.delete(`${process.env.REACT_APP_URL_RESERVATION}/banner-by-work-unit/`, {
        headers: { 'authentication-token': getJWT()! },
        data,
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }

  async deleteBannerByBusinessUnit(data: any): Promise<Object> {
    try {
      const res = await axios.delete(`${process.env.REACT_APP_URL_RESERVATION}/banner-by-business-unit/`, {
        headers: { 'authentication-token': getJWT()! },
        data,
      })
      return res.data
    } catch (error) {
      IsAuthorized(error)
      throw error
    }
  }
}

export const bannerServices = new BannerServices()
